import { LocaleStrings } from '../keys';

const ko: LocaleStrings = {
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Searchâ€¦',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  nav_stories: 'ìŠ¤í† ë¦¬',
  nav_create: 'ë§Œë“¤ê¸°',
  nav_login: 'ë¡œê·¸ì¸',

  page_title_main: 'Story Craft - ë©”ì¸ íŽ˜ì´ì§€',
  section_browse_by_category: 'ì¹´í…Œê³ ë¦¬ë³„ íƒìƒ‰',
  section_explore_new_games: 'ìƒˆë¡œìš´ ê²Œìž„ íƒìƒ‰',
  section_popular: 'ì¸ê¸°',
  section_trending: 'íŠ¸ë Œë”©',
  section_trending_now: '지금 트렌딩',
  section_popular_picks: '인기 작품',
  section_recent_stories: 'ìµœê·¼ ë³¸ ì´ì•¼ê¸°',
  section_new_stories: 'ìƒˆ ì´ì•¼ê¸°',
  btn_load_more_games: 'ë” ë³´ê¸° ({count}ê°œ ë‚¨ìŒ)',
  text_showing_games: '{total}ê°œ ì¤‘ {visible}ê°œ í‘œì‹œ',
  text_no_category_games: '{category} ê²Œìž„ì„ ì°¾ì„ ìˆ˜ ì—†ìŠµë‹ˆë‹¤.',
  text_category_games: '{category} ê²Œìž„',
  text_error_loading_games: 'ê²Œìž„ ë¡œë”© ì˜¤ë¥˜: {error}',

  tell_us_tagline: 'Story Craft: íŒ¬í”½ì…˜ì´ í”Œë ˆì´ ê°€ëŠ¥í•œ ìŠ¤í† ë¦¬ê°€ ë˜ëŠ” ê³³.',
  tell_us_subtitle: 'ì˜¤ëŠ˜ ê²Œìž„ì„ ì‹œìž‘í•˜ì„¸ìš”!',
  btn_create_now: 'ì§€ê¸ˆ ë§Œë“¤ê¸°',

  section_comments: 'ëŒ“ê¸€ ({count})',
  text_no_comments: 'ì•„ì§ ëŒ“ê¸€ì´ ì—†ìŠµë‹ˆë‹¤. ì²« ë²ˆì§¸ë¡œ ì˜ê²¬ì„ ê³µìœ í•˜ì„¸ìš”!',
  btn_load_more_comments: 'ëŒ“ê¸€ ë” ë³´ê¸°',
  text_posting_comment: 'ëŒ“ê¸€ ê²Œì‹œ ì¤‘...',
  text_failed_load_comments: 'ëŒ“ê¸€ì„ ë¶ˆëŸ¬ì˜¤ì§€ ëª»í–ˆìŠµë‹ˆë‹¤',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'ê²Œìž„ì„ ì°¾ì„ ìˆ˜ ì—†ìŒ - Story Craft',
  page_title_game_info: 'ê²Œìž„ ì •ë³´ - Story Craft',
  btn_play_now: 'í”Œë ˆì´',
  btn_rate: 'í‰ê°€',
  section_about: 'ì†Œê°œ',
  section_tags: 'íƒœê·¸',
  text_views: '{count}íšŒ ì¡°íšŒ',
  text_your_rating: 'ë‚´ í‰ê°€: {rating} - {title}',
  text_game_id: 'ê²Œìž„ ID: {id}',
  text_no_description: 'ì´ ê²Œìž„ì—ëŠ” ì„¤ëª…ì´ ì—†ìŠµë‹ˆë‹¤.',
  text_game_not_found: 'ê²Œìž„ì„ ì°¾ì„ ìˆ˜ ì—†ìŠµë‹ˆë‹¤',
  text_failed_load_game: 'ê²Œìž„ ì •ë³´ë¥¼ ë¶ˆëŸ¬ì˜¤ì§€ ëª»í–ˆìŠµë‹ˆë‹¤',

  section_similar_games: 'ë¹„ìŠ·í•œ ê²Œìž„',
  text_failed_load_similar: 'ë¹„ìŠ·í•œ ê²Œìž„ì„ ë¶ˆëŸ¬ì˜¤ì§€ ëª»í–ˆìŠµë‹ˆë‹¤',

  prefooter_btn_start: 'ðŸš€ Start for free',
  prefooter_btn_learn: 'Learn more â†’',

  hero_eyebrow: 'âœ¨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: 'ðŸš€ Start Creating',
  hero_btn_explore: 'ðŸ“– Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  footer_tagline: 'The #1 Interactive Story Creation Platform',

  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'Story Craft ëŒ“ê¸€ - ì—¬ê¸°ì„œ ì§ˆë¬¸í•˜ê³  ë‹µë³€í•˜ì„¸ìš”',

  section_featured: 'Story Craft ì¶”ì²œ',
  section_top_genre: 'Top {genre} ìŠ¤í† ë¦¬',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating storyâ€¦',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing contentâ€¦',
  translate_progress_step_generate: 'Generating translationsâ€¦',
  translate_progress_step_pack: 'Updating language packâ€¦',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogueâ€¦',
  translate_progress_flavor_2: 'Translating character linesâ€¦',
  translate_progress_flavor_3: 'Converting choicesâ€¦',
  translate_progress_flavor_4: 'Syncing tone of voiceâ€¦',
  translate_progress_flavor_5: 'Proofreadingâ€¦',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',
  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',
  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',
  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  rating_warn_title: '등급 {rating}',
  rating_warn_teen_body: '이 스토리는 T(청소년 13+) 등급입니다. 경미한 폭력, 암시적 내용 등 어린 독자에게 적합하지 않은 내용이 포함될 수 있습니다.',
  rating_warn_mature_body: '이 스토리는 M(성인 18+) 등급입니다. 강한 폭력, 성인 주제 등 성인 독자만을 위한 내용이 포함될 수 있습니다.',
  rating_warn_continue: '계속하기',
  rating_warn_go_back: '돌아가기',
  rating_warn_confirm_teen: '저는 만 13세 이상임을 확인합니다.',
  rating_warn_confirm_mature: '저는 만 18세 이상임을 확인합니다.',

  rating_section_title: '콘텐츠 등급',
  rating_label_e: '전체 이용가',
  rating_label_t: '청소년 13+',
  rating_label_m: '성인 18+',
  rating_desc_e: '모든 연령의 독자에게 적합합니다. 모든 사람에게 적합한 콘텐츠를 포함합니다.',

  hero_dialog_1: '해리 포터가 또 실수로 당신의 스토리에 잘못된 주문을 걸었어요.',
  hero_dialog_2: '세헤라자데는 해가 뜨기 전에 Mina에게 마지막 이야기를 들려주고 있어요…',
  hero_dialog_3: '셜록 홈즈가 사라진 플롯 홀을 발견하고 로딩 계속을 거부했어요.',
  hero_dialog_4: '드라큘라가 2장에 들어갈 허락을 기다리고 있어요.',
  hero_dialog_5: '프로도가 어쩐지 당신의 저장 파일을 운명의 산에 떨어뜨렸어요.',
  hero_dialog_6: '해리 포터와 Mina가 타임라인 붕괴의 원인을 놓고 다투고 있어요.',
  hero_dialog_7: '신데렐라가 또 자정을 놓쳐서 로딩 화면이 연장됐어요.',
  hero_dialog_8: '로미오와 줄리엣이 당신의 나쁜 엔딩에 조금 너무 일찍 도달했어요.',
  hero_dialog_9: '앨리스가 잘못된 토끼 굴을 열어 당신의 초안 폴더에 들어갔어요.',
  hero_dialog_10: 'Mina는 더 이상 금지된 책을 읽지 않겠다고 약속했어요. Mina는 거짓말했어요.',
  hero_dialog_11: '멀린이 스토리 엔진의 마법 버그를 패치하고 있어요.',
  hero_dialog_12: '오디세우스는 10년 동안 다음 챕터에 도달하려고 노력하고 있어요.',
  hero_dialog_13: '프랑켄슈타인 박사가 코드베이스를 건드렸어요. 이제 아무도 안전하지 않아요.',
  hero_dialog_14: '피터 팬이 이 스토리가 커지는 걸 거부하고 있어요.',
  hero_dialog_15: '어린 왕자가 Mina에게 어른들은 왜 그렇게 비극적인 결말을 많이 쓰냐고 물었어요.',
};
export default ko;
